import { Chip, IconButton, Link } from '@mui/material'
import InformationTable from '../../../../components/Table/InformationTable'
import { useQuery } from '@tanstack/react-query'
import { useNotification } from '../../../../context/NotificationManager/NotificationManager'
import { downloadCSVFile, getCSVContent } from '../../../../utils/csv'
import TableHeader from '../../../../components/TableHeader/TableHeader'
import PageLoading from '../../../../components/PageLoading/PageLoading'
import { dateToString } from '../../../../utils/date'
import { format, formatForExport } from '../../../../utils/math'
import { getIngresosCentro } from '../../../../utils/api/ingresos'
import { useState } from 'react'
import { dateTimeSort, numberSort, textFilter } from '../../../../utils/table'
import css from './Ingresos.module.css'

const Ingresos = ({ mes }) => {
  const notification = useNotification()

  const [search, setSearch] = useState('')

  const { isLoading, data: ingresoList = [] } = useQuery({
    queryKey: ['contabilidad', 'ingreso-alumno', 'list', 'month', mes],
    queryFn: () =>
      getIngresosCentro(mes)
        .then(datos =>
          datos
            .sort((a, b) => b.fecha - a.fecha)
            .map(pago => ({
              ...pago,
              fecha: dateToString(pago.fecha)
            }))
        )
        .catch(err => {
          notification.error({
            title: 'Error al recuperar los ingresos',
            content: err
          })
          return []
        })
  })

  const handleExport = () => {
    const content = getCSVContent({
      columns: [
        'Alumno',
        'Fecha',
        'Concepto',
        'Centro',
        'Importe',
        'Forma de Pago'
      ],
      data: ingresoList,
      transform: c => [
        c.alumno,
        `${c.fecha} ${c.hora}`,
        c.concepto,
        c.centro,
        formatForExport(c.importe),
        c.formaPago
      ]
    })
    downloadCSVFile(content, `ingresos-${mes}`)
  }

  const filterSearch = pago => {
    return textFilter({
      object: pago,
      fields: ['alumno', 'fecha', 'concepto', 'formaPago', 'importe'],
      search: search
    })
  }

  const ingresos = format(
    ingresoList.reduce((acc, pago) => acc + pago.importe, 0)
  )

  return (
    <PageLoading isLoading={isLoading}>
      <TableHeader
        actions={
          <div className={css.actions}>
            <IconButton
              className={css.download}
              size='small'
              color='primary'
              onClick={handleExport}
            >
              <i className='material-icons'>download</i>
            </IconButton>
            {!isLoading && (
              <Chip
                className={css.chip}
                label={`Ingresos: ${ingresos}€`}
                color='secondary'
                variant='outlined'
              />
            )}
          </div>
        }
        title='Ingresos del mes'
        search={search}
        onSearchChange={e => setSearch(e.target.value)}
      />
      <InformationTable
        details={[
          { title: 'Alumno', key: 'alumno', sortKey: 'alumnoNombre' },
          { title: 'Fecha', key: 'fecha', sortFunction: dateTimeSort },
          { title: 'Importe', key: 'importe', sortFunction: numberSort },
          { title: 'Forma de pago', key: 'tipoPago' },
          { title: 'Concepto', key: 'concepto' }
        ]}
        data={ingresoList.filter(filterSearch).map(pago => ({
          alumnoNombre: pago.alumno,
          alumno: (
            <Link className={css.link} href={`/alumnos/${pago.alumnoId}/ficha`}>
              {pago.alumno}
            </Link>
          ),
          fecha: `${pago.fecha} ${pago.hora}`,
          importe: `${format(pago.importe)} €`,
          tipoPago: pago.formaPago,
          concepto: pago.concepto
        }))}
        isFetching={isLoading}
      />
    </PageLoading>
  )
}

export default Ingresos
